import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster } from 'react-hot-toast';
import { useBreakpoint, zIndices } from '@design-system/theme';
import { DURATION } from './constants';
import { Toast } from './Toast';
export const ToastsContainer = ({ horizontalInset = 16, position = 'top-right', verticalInset = 32, }) => {
    const breakpoint = useBreakpoint();
    return (_jsx(Toaster, { containerStyle: {
            inset: breakpoint === 's'
                ? `${verticalInset}px 0px`
                : `${verticalInset}px ${horizontalInset}px`,
            zIndex: zIndices.toast,
        }, gutter: 16, position: position, reverseOrder: true, toastOptions: {
            duration: DURATION,
        }, children: (t) => (_jsx(Toast, { duration: t.duration, id: t.id, message: t.message, text: t.text, type: t.type, visible: t.visible })) }));
};
//# sourceMappingURL=ToastsContainer.js.map